itsoftApp.createModule("slider", function() {
    new Swiper(".main-slider", {
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 4000,
        },
        speed: 1000,
        navigation: {
            nextEl: ".main-slider .swiper-button-next",
            prevEl: ".main-slider .swiper-button-prev",
        },
    });
    new Swiper(".catalog-slider .swiper-container", {
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        simulateTouch: false,
        loopAdditionalSlides: 1,
        navigation: {
            nextEl: ".catalog-slider .swiper-button-next",
            prevEl: ".catalog-slider .swiper-button-prev",
        },
        pagination: {
            el: ".catalog-slider .swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return "<span class=\"" + className + "\">" + "</span>";
            },
        },
        breakpoints: {
            950: {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: false,
                simulateTouch: true
            }
        }
    });
});